import { useNavigate } from "react-router-dom";
import { Grid, Paper } from "@mui/material";

import Page from "./Page";
import useClientDashboard from "../../hooks/useClientDashboard";
import Loading from "../ui/Loading";

import ClientDashboardFilters from "../dashboard/ClientDashboardFilters";
import UnbilledByClientChart from "../dashboard/UnbilledByClientChart";
import YtdInvoicingCard from "../dashboard/YtdInvoicingCard";

const ClientDashboard = () => {
  const navigate = useNavigate();
  const {
    filters,
    updateFilters,
    unbilledByClient,
    ytdInvoicing,
    callsDetail,
    invoicesDetail,
    getCalls,
    getInvoices,
    isLoading,
  } = useClientDashboard();

  const handleFilterChange = (newFilters) => {
    updateFilters(newFilters);
  };

  const handleToolBarClick = (item) => {
    switch (item) {
      case "callDashboard":
        navigate("/home");
        break;

      case "syncDashboard":
        navigate("/syncdashboard");
        break;

      case "surveyDashboard":
        navigate("/surveymetrics");
        break;

      case "orderDashboard":
        navigate("/orderdashboard");
        break;

      case "repDashboard":
        navigate("/repdashboard");
        break;

      default:
        break;
    }
  };

  if (isLoading && !unbilledByClient.data && !ytdInvoicing.data) {
    return <Loading />;
  }

  return (
    <Page
      pageName="clientDashboard"
      includeToolbar={true}
      onToolItemClick={handleToolBarClick}
      items={[
        { name: "callDashboard", iconName: "CalendarMonth" },
        { name: "syncDashboard", iconName: "CloudSync" },
        { name: "surveyDashboard", iconName: "Assignment" },
        { name: "orderDashboard", iconName: "ShoppingCart" },
        { name: "repDashboard", iconName: "People" },
      ]}
    >
      <Paper sx={{ p: 2, mb: 3 }}>
        <ClientDashboardFilters
          filters={filters}
          onChange={handleFilterChange}
        />
      </Paper>

      <Grid
        container
        spacing={3}
      >
        <Grid
          xs={12}
          md={6}
        >
          <UnbilledByClientChart
            data={unbilledByClient.data}
            isLoading={unbilledByClient.isLoading}
            error={unbilledByClient.error}
            filters={filters}
            callsDetail={callsDetail}
            getCalls={getCalls}
          />
        </Grid>
        <Grid
          xs={12}
          md={6}
        >
          <YtdInvoicingCard
            data={ytdInvoicing.data}
            isLoading={ytdInvoicing.isLoading}
            error={ytdInvoicing.error}
            filters={filters}
            invoicesDetail={invoicesDetail}
            getInvoices={getInvoices}
          />
        </Grid>
      </Grid>
    </Page>
  );
};

export default ClientDashboard;
